import React from 'react';
import UnifiedPdfCitationViewer from './UnifiedPdfCitationViewer';

interface HtmlPdfViewerProps {
  documentUrl: string;
  citation: {
    documentId: string;
    documentName: string;
    page: number;
    startOffset: number;
    endOffset: number;
    text: string;
    context?: string;
  };
  onClose: () => void;
  allCitations?: any[];
}

/**
 * Legacy HTML PDF Viewer - Redirects to UnifiedPdfCitationViewer
 * 
 * This component has been replaced with UnifiedPdfCitationViewer
 * to avoid PDF.js version conflicts and provide consistent experience.
 */
const HtmlPdfViewer: React.FC<HtmlPdfViewerProps> = ({ 
  citation,
  onClose
}) => {
  return (
    <UnifiedPdfCitationViewer
      documentId={citation.documentId}
      citation={citation}
      onClose={onClose}
    />
  );
};

export default HtmlPdfViewer;